import {Trans, useTranslation} from 'react-i18next';
import {useIVOnProperty} from 'hooks/useIVOnProperty';
import {AlertBox, AlertSize} from '@chekinapp/ui';

function IVOnPropertyAlertBoxes() {
  const {t} = useTranslation('identity-verification');
  const {isIVOnPropertyUnavailable} = useIVOnProperty();
  const alertMessage = isIVOnPropertyUnavailable
    ? 'when_you_arrive_scan_qr_code_at_entrance_to_complete_iv'
    : 'identity_verification_process_now_available_scan_qr_code_at_property';

  return (
    <AlertBox size={AlertSize.S}>
      <Trans i18nKey={alertMessage} t={t} />
    </AlertBox>
  );
}

export {IVOnPropertyAlertBoxes};
